import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../Components/Authservice.ts";
import "../App.css"; // Make sure to include your custom styles here

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [bio, setBio] = useState("");
  const [patreonUrl, setPatreonUrl] = useState("");
  const [role, setRole] = useState("Viewer");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    
    if (!agreeToTerms) {
      setError("You must agree to the Terms of Service and Privacy Policy to register.");
      return;
    }
    
    try {
      const roleValue = role.trim().toLowerCase();
      const extraData = roleValue === "creator"
        ? { username, bio, patreonUrl }
        : {};

      await registerUser(email, password, roleValue, extraData);
      navigate("/login");
    } catch (error) {
      console.error("Signup error:", error);
      setError(error.message);
    }
  };

  return (
    <div className="signup-background">
      <form onSubmit={handleSignup} className="signup-form">
        <h2 className="signup-title">Sign up</h2>
        <p className="signup-subtitle">
          Create an account to start watching or uploading anime
        </p>

        {error && <p className="signup-error">{error}</p>}

        <div className="signup-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="signup-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="signup-group">
          <label>Account Type</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="Viewer">Viewer</option>
            <option value="Creator">Creator</option>
          </select>
        </div>

        {role === "Creator" && (
          <>
            <div className="signup-group">
              <label>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="signup-group">
              <label>Bio</label>
              <textarea
                value={bio}
                onChange={(e) => setBio(e.target.value)}
              />
            </div>
            <div className="signup-group">
              <label>Patreon URL</label>
              <input
                type="url"
                value={patreonUrl}
                onChange={(e) => setPatreonUrl(e.target.value)}
              />
            </div>
          </>
        )}

        <div className="signup-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
              required
            />
            <span className="checkbox-text">
              I agree to the{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </span>
          </label>
        </div>

        <button type="submit" className="signup-button">
          Register
        </button>

        <p className="signup-footer">
          Already have an account? <a href="/login">Log in</a>
        </p>
      </form>
    </div>
  );
};

export default Signup;